

import React, { Component } from 'react';
import styles from './TranslatableVars.css';
import withStyles from '../../decorators/withStyles';


class TranslatableVars extends Component {

  render() {
    return (
        <div className="TranslatableVars">
          <span>days</span>
          <span>Days of Coastal Flooding</span>
          <span>Driven by climate-linked sea level rise</span>
          <span>Enter a U.S. coastal place</span>
          <span>feet</span>
          <span>Housing units</span>
          <span>Housing units: growth rate per decade</span>
          <span>million</span>
          <span>Percentage of housing units: growth rate per decade</span>
          <span>Percentage of population: growth rate per decade</span>
          <span>Percentage of property value: growth rate per decade</span>
          <span>Percentage of road miles: growth rate per decade</span>
          <span>Population: growth rate per decade</span>
          <span>Property value ($M): growth rate per decade</span>
          <span>Property value ($M)</span>
          <span>Road miles</span>
          <span>Road miles: growth rate per decade</span>
          <span>Ten-year Period</span>
          <span>Water Level (ft)</span>
          <span>Would have occurred anyway</span>
          <span>% of housing units: growth rate per decade</span>
          <span>% of population: growth rate per decade</span>
          <span>% of property value: growth rate per decade</span>
          <span>% of road miles: growth rate per decade</span>
        </div>
    );
  }

}

export default withStyles(styles)(TranslatableVars);
